<template>
	<div>
        <div class="uk-container">
                                <div style="height: 150px;position: relative;color: #cccccc;">
                                  <img style="  width: 240px;position: absolute;top: 30px;" src="https://wyjs.ca163.net/img/jianghai.png">
                                  <div style="height: 13px;position: absolute;top: 40px;left: 329px;font-size: 13px;line-height: 20px;color: #999999;margin-right: 20px;  display: inline;color: #999999;">
                                    <span style="margin-right: 20px;">版权所有©五邑大学</span>
                                    <div style="margin-right: 20px;">技术支持： 广州润沁教育科技有限公司 </div>
                                    <a style="display: inline;color: #999999;" href="http://www.beian.miit.gov.cn" target="_blank">广东省江门市蓬江区东成村22号</a>
                                    <span style="margin-left: 10px;">邮编：529020</span>
                                  </div>
                                  <div id="modal-link-us" uk-modal>
                                    <div class="uk-modal-dialog uk-modal-body">
                                      <h2 class="uk-modal-title">联系我们</h2>
                                      <p>客服信息:<br /> 4008-032-321<br />周一~周五 &nbsp;&nbsp;08:30-17:30</p>
                                      <p class="uk-margin-small-top">13535300254<br />周一~周五 17:30-22:00
                                        </br>周六~周日 10:00-22:00</p>
                                      <p class="uk-margin-small-top">客服QQ:&nbsp;&nbsp;
                                        <a href="http://wpa.qq.com/msgrd?v=3&uin=1848331480&site=qq&menu=yes">1848331480</a>
                                        <a href="http://wpa.qq.com/msgrd?v=3&uin=645524520&site=qq&menu=yes">645524520</a>
                                      </p>
                                      <p class="uk-margin-small-top">客服邮箱:&nbsp;&nbsp;
                                        <a>service@ca163.net</a>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
        
        
        
        <div style="margin: 20px;">
            <el-input type="area" v-model="json"/>
        </div>
        
        <div class="button-view">
            <el-button type="primary" size="mini" @click="toJsonParse">解析</el-button>
            <el-button type="primary" size="mini" @click="look">查看</el-button>
            <el-button type="success" size="mini" @click="toJsonIfy">打印</el-button>
            <el-button type="success" size="mini" @click="isNull">清空</el-button>
        </div>
        
        <div style="margin: 20px;">
            解析后：
            <el-input type="area" v-model="ify"/>
        </div>
        
        <div style="margin: 20px;">
            <el-collapse>
              <el-collapse-item  v-for="(item,index) in parse" :key="index" :title="item.task_desc" :name="item.task_desc + index">
                  <div style="padding-left: 40px;">
                      <el-collapse>
                        <el-collapse-item  v-for="(task,taskIndex) in item.task_activities" :key="task.activitie_desc + taskIndex" :name="task.activitie_desc + taskIndex" :title="task.activitie_desc">
                            <template slot="title">
                                <el-checkbox-group v-model="task.activeState">
                                   <el-checkbox @change="allProgressChange(index,taskIndex)" v-model="task.activeState" :true-label="2" :false-label="1"></el-checkbox>
                                 </el-checkbox-group>
                                 <span style="margin-left: 20px;">{{task.activitie_desc}}</span>
                            </template>
                            <div v-for="(resources,resourcesIndex) in task.resources[0].items" :key="resources.name + resourcesIndex">
                                 <el-checkbox-group v-model="resources.progress">
                                     <div style="margin-left: 20px;">
                                        <el-checkbox @change="progressChange(index,taskIndex,resourcesIndex)" v-model="resources.progress" :true-label="1" :false-label="0">{{resources.name}}</el-checkbox> 
                                     </div>
                                  </el-checkbox-group>
                            </div>
                        </el-collapse-item>
                      </el-collapse>
                  </div>
              </el-collapse-item>
            </el-collapse>
        </div>
	</div>
</template>
<script>
import axios from 'axios';
export default {
	data() {
		return {
			json:"",
            parse:[],
            ify:null
		};
	},
	methods: {
        // 解析数组
        toJsonParse(){
            this.parse = JSON.parse(this.json)
            console.log(this.parse)
        },
        // 查看JSON数组
        look(){
            console.log(this.parse)
        },
        // 序列化数组
        toJsonIfy(){
            this.ify = JSON.stringify(this.parse)
        },
        // 清空
        isNull(){
            this.ify = null
        },
        // 单选完成进度
        progressChange(index,taskIndex,resourcesIndex){
            let items = this.parse[index].task_activities[taskIndex].resources[0].items
            console.log(items)
            
            // 返回进度为1的数组
            let finish = items.filter(function (value, index, array) {
                return value.progress === 1;
            });
            console.log(finish)
            
            // 进度为1的数组个数等于活动个数就把活动状态改为已完成
            finish.length === items.length ? this.parse[index].task_activities[taskIndex].activeState = 2 : this.parse[index].task_activities[taskIndex].activeState = 1
            console.log(this.parse[index].task_activities[taskIndex])
        },
        // 全选完成进度
        allProgressChange(index,taskIndex){
            console.log(this.parse[index].task_activities[taskIndex])
            let items = this.parse[index].task_activities[taskIndex].resources[0].items
            
            if(this.parse[index].task_activities[taskIndex].activeState === 2){
                // 如果是全选状态的话就把活动里面的资源状态改为已完成
                items.map(item=>{
                    item.progress = 1
                })
            }else{// 如果活动下面的资源都是已完成的话就不让取消全选
                // 返回进度为1的数组
                let finish = items.filter(function (value, index, array) {
                    return value.progress === 1;
                });
                console.log(finish)
                
                // 进度为1的数组个数等于活动个数就把活动状态改为已完成
                finish.length === items.length ? this.parse[index].task_activities[taskIndex].activeState = 2 : this.parse[index].task_activities[taskIndex].activeState = 1
            }
        }
    },
	mounted() {
        
    }
};
</script>

<style>
    .button-view{
        margin: 40px;
        display: flex;
        
        button{
            margin-left: 20rpx;
        }
    }
</style>
